export const setObjectValues = (obj: object, callback: (name: string, value: any) => void) => {
  const values = Object.entries(obj);

  values.forEach(([key, value]) => {
    callback(key, value);
  });
};
